import { BaseElement } from '@webtides/element-js';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock/lib/bodyScrollLock.es6';
import MainNavigationEvents from './main-navigation-events';

const MENU_OPEN_STATE = { menu: 1 };

export default class MainNavigation extends BaseElement {
    #activeFirstLevelItem = null;
    constructor() {
        super();
        this.$firstLevelItems = Array.from(this.querySelectorAll('.first-level-item '));
        this.$firstLevelMenuItems = this.$firstLevelItems.filter(item => item.querySelector('[data-submenu]') !== null);
        this._secondLevelScrollArea = false;
        this._firstLevelScrollArea = this.querySelector('[data-menu]');
    }

    properties() {
        return {
            open: false,
        };
    }

    connected() {
        this.determineSubMenuPositions();
    }
    watch() {
        return {
            open: () => {
                if (this.open) {
                    this.classList.add('is-open');
                    this.dispatch(MainNavigationEvents.MENU_OPEN, null, true);
                    disableBodyScroll(this._firstLevelScrollArea);

                    if (history.state !== MENU_OPEN_STATE) {
                        history.pushState(MENU_OPEN_STATE, 'menu:open');
                    }
                } else {
                    this.classList.remove('is-open');
                    this.resetSecondLevel();
                    this.dispatch(MainNavigationEvents.MENU_CLOSE, null, true);
                    enableBodyScroll(this._firstLevelScrollArea);
                }
            },
        };
    }

    events() {
        return {
            '[ref=openMenu]': {
                click: () => {
                    this.open = true;
                },
            },
            '[ref=closeMenu]': {
                click: () => {
                    this.open = false;
                },
            },
            '[ref=backMenu]': {
                click: () => this.resetSecondLevel(),
            },
            '.first-level-item': {
                click: e => {
                    const active = e.currentTarget;
                    if (!this.$firstLevelMenuItems.includes(active) || this.open === false) {
                        // no sub menu no open OR desktop mode
                        return;
                    }
                    this.$firstLevelMenuItems.forEach(menuItem => {
                        if (menuItem === active) {
                            this.$refs.backMenu.classList.remove('hidden');
                            this.$refs.mobileLogo.classList.add('hidden');
                            menuItem.classList.add('active');
                            const title = active.dataset.title;
                            this.$refs.menuTitle.innerText = title.trim();
                            this._secondLevelScrollArea = menuItem.querySelector('[data-submenu]');
                            disableBodyScroll(this._secondLevelScrollArea);
                        } else {
                            menuItem.classList.remove('active');
                        }
                    });
                },
                mouseenter: ev => {
                    //lock instant to cutrrent item
                    clearTimeout(this.showMenuTimer);
                    clearTimeout(this.activeTimer);
                    clearTimeout(this.resetTimer);
                    const { currentTarget } = ev;
                    this.showMenuTimer = setTimeout(() => this.showActiveSubMenu(), 300);
                    this.activeTimer = setTimeout(() => {
                        this.#activeFirstLevelItem = currentTarget;
                    }, 100);
                },

                mouseleave: ev => {
                    clearTimeout(this.activeTimer);
                    clearTimeout(this.showMenuTimer);
                    this.resetTimer = setTimeout(() => {
                        this.#activeFirstLevelItem = null;
                        this.showActiveSubMenu();
                    }, 100);
                },
            },
            window: {
                resize: () => {
                    this.determineSubMenuPositions();
                    const style = window.getComputedStyle(this.$refs.mobileHeader);
                    if (style.display === 'none') {
                        //close to enable body scroll while resizing to desktop state
                        this.open = false;
                    }
                },
                popstate: () => {
                    this.open = false;
                },
                load: () => {
                    this.determineSubMenuPositions();
                },
            },
        };
    }

    showActiveSubMenu() {
        this.$firstLevelMenuItems.forEach(menuItem => {
            if (menuItem === this.#activeFirstLevelItem) {
                menuItem.classList.add('show-submenu');
            } else {
                menuItem.classList.remove('show-submenu');
            }
        });
    }

    resetSecondLevel() {
        this.$firstLevelItems.forEach(menuItem => {
            menuItem.classList.remove('active');
            this.$refs.menuTitle.innerText = '';
            this.$refs.backMenu.classList.add('hidden');
            this.$refs.mobileLogo.classList.remove('hidden');
        });
        //reset scroll lock
        if (this._secondLevelScrollArea) {
            enableBodyScroll(this._secondLevelScrollArea);
            this._secondLevelScrollArea = false;
        }
    }

    determineSubMenuPositions() {
        /**
         * positions the submenus to not leave headers container
         */
        if (!this.offsetParent) {
            return;
        }
        const containerWidth = this.offsetParent.offsetWidth;
        const menuContainerLeft = this.offsetLeft;

        this.$firstLevelMenuItems.forEach(menuItem => {
            const subMenuLeft = menuItem.offsetLeft;
            const menuItemWidth = menuItem.offsetWidth;

            const spaceLeft = menuContainerLeft + subMenuLeft + menuItemWidth * 0.5;
            const spaceRight = containerWidth - spaceLeft;

            const submenu = menuItem.querySelector('[data-submenu]');

            if (spaceLeft < submenu.offsetWidth * 0.5) {
                submenu.style.setProperty('--subMenuTransform', `-${spaceLeft}px`);
            } else if (spaceRight < submenu.offsetWidth * 0.5) {
                submenu.style.setProperty('--subMenuTransform', `-${submenu.offsetWidth - spaceRight}px`);
            }
        });
    }
}
